"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCharacterCategory = exports.characterRoleSchema = exports.characterRoleList = exports.characterCategorySchema = exports.characterCategoryList = exports.characterDurationSchema = exports.characterIdSchema = void 0;
var joi = __importStar(require("joi"));
var utils_1 = require("../utils");
var inferFn_1 = require("../utils/inferFn");
exports.characterIdSchema = joi.string().required().min(1);
exports.characterDurationSchema = joi.number().required().integer().min(0);
exports.characterCategoryList = ['offensive', 'support', 'placement'];
exports.characterCategorySchema = exports.characterCategoryList;
var characterRoleMap = inferFn_1.inferFn()({
    'tacka': 'offensive',
    'vemo': 'placement',
    'meti': 'support'
});
exports.characterRoleList = utils_1.ObjectTyped.keys(characterRoleMap);
exports.characterRoleSchema = exports.characterRoleList;
var getCharacterCategory = function (characterRole) { return characterRoleMap[characterRole]; };
exports.getCharacterCategory = getCharacterCategory;
